import { ForwardedRef, forwardRef } from "react";

// Material Dashboard 2 PRO React components
import { MDTypography } from "../MDTypography";

// Custom styles for MDProgress
import MDProgressRoot from "../MDProgress/MDProgressRoot";
import { BaseProps } from "@mui/material/OverridableComponent";


// Typechecking props for the MDProgress
interface IMDProgressProps {
  variant: "contained" | "gradient";
  color: "primary" |"secondary" |"info" |"success" |"warning" |"error" |"light" |"dark";
  value: number;
  label: boolean,
};

export const MDProgress = forwardRef(({ 
  variant = "contained",
  color = "info",
  value = 0,
  label = false,
  ...rest 
}: BaseProps<any>, ref: ForwardedRef<any>) => (
  <>
    {label && (
      <MDTypography variant="button" fontWeight="medium" color="text">
        {value}%
      </MDTypography>
    )}
    <MDProgressRoot
      {...rest}
      ref={ref}
      variant="determinate"
      value={value}
      ownerState={{ color, value, variant }}
    />
  </>
));
